import type { BenefitTier } from "@yutai/shared"
import styles from "./BenefitTiersTable.module.css"
import { HighlightMatch } from "./HighlightMatch.js"

interface Props {
  tiers: BenefitTier[]
  query?: string
  className?: string
}

export function BenefitTiersTable({ tiers, query = "", className }: Props) {
  if (tiers.length === 0) return null

  return (
    <table className={className ? `${styles.tiers} ${className}` : styles.tiers}>
      <tbody>
        {tiers.map((tier, i) => (
          <tr key={`${tier.minimumShares}-${i}`} className={styles.tierRow}>
            <td className={styles.tierShares}>
              {tier.minimumShares != null
                ? `${tier.minimumShares.toLocaleString()}株以上`
                : "株数不明"}
            </td>
            <td className={styles.tierDescCell}>
              {query ? <HighlightMatch text={tier.description} query={query} /> : tier.description}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
